import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WithdrawComponent } from 'src/app/feature/modules/withdraw/components/withdraw/withdraw.component';
import { WithdrawRialComponent } from './components/withdraw-rial/withdraw-rial.component';

const routes: Routes = [
  {
    path: '',
    component: WithdrawComponent
  },
  {
    path: 'rial',
    component: WithdrawRialComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WithdrawRoutingModule {}
